var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_602",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.854004H0V16.854H16V0.854004Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.333 2.85396V5.52063M14.6664 4.1873H11.9997M2.66634 12.1873V13.5206M3.333 12.854H1.99967M6.6243 11.1873C6.56478 10.9566 6.44452 10.746 6.27604 10.5776C6.10756 10.4091 5.89701 10.2888 5.6663 10.2293L1.5763 9.17463C1.50652 9.15483 1.4451 9.1128 1.40137 9.05493C1.35764 8.99706 1.33398 8.9265 1.33398 8.85397C1.33398 8.78143 1.35764 8.71087 1.40137 8.653C1.4451 8.59513 1.50652 8.55311 1.5763 8.5333L5.6663 7.47797C5.89693 7.4185 6.10743 7.29835 6.2759 7.12999C6.44437 6.96164 6.56467 6.75122 6.6243 6.52063L7.67896 2.43063C7.69857 2.36058 7.74055 2.29886 7.79851 2.2549C7.85647 2.21093 7.92722 2.18713 7.99996 2.18713C8.07271 2.18713 8.14346 2.21093 8.20142 2.2549C8.25937 2.29886 8.30136 2.36058 8.32096 2.43063L9.37496 6.52063C9.43448 6.75135 9.55474 6.9619 9.72322 7.13038C9.8917 7.29886 10.1023 7.41911 10.333 7.47863L14.423 8.53263C14.4933 8.55203 14.5554 8.59397 14.5996 8.65202C14.6438 8.71006 14.6677 8.78101 14.6677 8.85397C14.6677 8.92693 14.6438 8.99787 14.5996 9.05591C14.5554 9.11396 14.4933 9.1559 14.423 9.1753L10.333 10.2293C10.1023 10.2888 9.8917 10.4091 9.72322 10.5776C9.55474 10.746 9.43448 10.9566 9.37496 11.1873L8.3203 15.2773C8.30069 15.3474 8.25871 15.4091 8.20075 15.453C8.14279 15.497 8.07204 15.5208 7.9993 15.5208C7.92655 15.5208 7.8558 15.497 7.79784 15.453C7.73989 15.4091 7.6979 15.3474 7.6783 15.2773L6.6243 11.1873Z",
    stroke: "#3F3F46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.cf477b0f136d35607289a29892b29969.svg";
export { ForwardRef as ReactComponent };